<template>
    <div class="podcast2-index">
        <admin-layout>
            <app-content-pane class="ml-3">
                <template #title>
                    <div  class="px-4 pt-3">
                        <h1 class="mb-2">
                            {{form.name}}
                        </h1>
                        <h6 class="text-muted">
                            <strong>Podcast</strong> /
                           {{form.name}}
                        </h6>
                    </div>
                    <hr class="mb-0">
                </template>

                <section class="px-3 py-4 form">
                    <form action="" @submit.prevent="" autocomplete="off">
                        <div class="row">

                            <div class="col-12 col-lg-6">
                                <h5>Podcast Details</h5>
                                <div class="form-group">
                                    <label>Podcast Name</label>
                                    <input type="text"
                                           class="form-control"
                                           v-model="form.name"
                                           placeholder/>
                                    <error-line field="name"/>
                                </div>

                                <div class="form-group">
                                    <label>Slug</label>
                                    <input type="text" class="form-control" v-model="form.slug"/>
                                    <error-line field="slug"/>
                                </div>

                                <div class="checkboxes stage-row">
                                    <div class="checkbox stage" v-for="stage in stages" :key="stage.id">
                                        <image-check v-model="form.groups"
                                                     :value="stage.id"
                                                     :image="stage.meta?.icon">
                                            {{ stage.description }}
                                        </image-check>
                                    </div>
                                    <error-line field="stage"/>
                                </div>

                                <div class="form-group">
                                    <label>Podcast Description</label>
                                    <textarea type="text" class="form-control" v-model="form.description"></textarea>
                                    <error-line field="description"/>
                                </div>
                                <div class="form-group">
                                    <label>Picture</label>
                                    <div class="form-group">
                                        <file-uploader storage-path="podcasts" v-model="form.image_file" />
                                    </div>
                                    <error-line field="image_file"/>
                                </div>
                                <error-line field="file"/>

                                <div class="form-group">
                                    <label>Duration in minutes</label>
                                    <input type="number" class="form-control" v-model="form.duration_mins"/>
                                    <error-line field="duration_mins"/>
                                </div>

                                <div class="form-group">
                                    <label>Priority</label>
                                    <input type="number" class="form-control" v-model="form.priority"/>
                                    <error-line field="priority"/>
                                </div>
                                <div class="form-group">
                                    <label>Difficulty</label>
                                    <select class="form-control" v-model="form.difficulty">
                                        <option value="Beginner">Beginner</option>
                                        <option value="Intermediate">Intermediate</option>
                                        <option value="Advanced">Advanced</option>
                                    </select>
                                    <error-line field="difficulty"/>
                                </div>
                                <div class="form-group">
                                    <label>Theme</label>
                                    <select class="form-control" v-model="form.course">
                                        <option value="justice">Racial Justice</option>
                                        <option value="climate">Climate Action</option>
                                        <option value="education">Education Equity</option>
                                        <option value="others">Others</option>
                                    </select>
                                    <error-line field="course"/>
                                </div>
                                <div class="form-group">
                                    <label>Type</label>
                                    <select class="form-control" v-model="form.type">
                                        <option value="audio">Audio</option>
                                        <option value="video">Video</option>
                                    </select>
                                </div>

                                <template v-if="form.type === 'audio'">

                                    <!-- AUDIO PODCAST FIELDS -->

                                    <div class="form-group">
                                        <label>Audio File (mp3,wav,m4a)</label>
                                        <file-uploader storage-path="podcasts" v-model="form.media"/>
                                        <error-line field="media"/>
                                    </div>

                                </template>

                                <template v-else>

                                    <!-- VIDEO PODCAST FIELDS -->

                                    <div class="form-group">
                                        <label>Vimeo URL</label>
                                        <input type="text" class="form-control" v-model="form.media.url"/>
                                        <error-line field="media.url"/>
                                    </div>

                                </template>


                                <div class="form-group">
                                    <label>Transcript</label>
                                    <div class="form-group">
                                        <file-uploader storage-path="podcasts" v-model="form.transcript_file"/>
                                        <error-line field="transcript_file"/>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>Global Goal</label>
                                    <div class="checkboxes global-goal-row">
                                        <div class="checkbox global-goal" v-for="theme in themes" :key="theme.id">
                                            <image-check type="radio" v-model="form.global_goal_id"
                                                        :value="theme.id"
                                                        :image="theme.icon">
                                                {{ theme.name }}
                                            </image-check>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-lg-6">
                                <h5>Sponsors</h5>
                                <div class="form-group">
                                    <label>Sponsor Name</label>
                                    <input type="text" class="form-control" v-model="form.sponsor.name"/>
                                    <error-line field="sponsor.name"/>
                                </div>
                                <div class="form-group">
                                    <label>Sponsor URL</label>
                                    <input type="text" class="form-control" v-model="form.sponsor.url"/>
                                    <error-line field="sponsor.url"/>
                                </div>
                                <div class="form-group">
                                    <label>Sponsor Logo</label>
                                    <div class="form-group">
                                        <file-uploader storage-path="podcasts" v-model="form.sponsor.logo"/>
                                        <error-line field="sponsor.logo"/>
                                    </div>
                                </div>

                                <groups-connector v-model="form.groups"/>

                            </div>

                        </div>
                        <div class="form-group">
                            <state-button type="submit"
                                          class="btn btn-primary"
                                          :disabled="form.processing"
                                          :state="form.processing ? 'busy' : ''"
                                          @click="save">Save</state-button>
                        </div>

                    </form>
                </section>
            </app-content-pane>
        </admin-layout>
    </div>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import AppContentPane from "@/Components/AppContentPane";
import FileUploader from "@/Components/Common/FileUploader";
import IconCheck from "@/Icons/IconCheck";
import ImageCheck from "@/Components/Common/ImageCheck";
import themes from "@/DATA/themes.js"
import ErrorLine from "@/Components/Common/ErrorLine";
import utils from "@/mixins/utils";
import StateButton from "@/Components/Common/StateButton";
import API from "@/API";
import GroupsConnector from "@/Components/Common/GroupsConnector";

export default {
    name: "Edit",
    components: {
        GroupsConnector,
        StateButton,
        AppContentPane,
        AdminLayout,
        FileUploader,
        IconCheck,
        ImageCheck,
        ErrorLine
    },

    mixins: [utils],
    props: ['podcast', 'groups'],

    data() {
        return {

            themes: [],

            search:'',

            form: this.$inertia.form({
                global_goal_id: null,
                course: 'others',
                sponsor: {
                    name: '',
                    url: '',
                    logo: null,
                },
                priority: 0,
                media: null,
                name: 'Untitled Podcast',
                slug: 'untitled-podcast',
                description: '',
                image_file: null,
                transcript_file: null,
                duration_mins: 0,
                difficulty: 'Beginner',
                type: 'audio',
                groups: [],
            }),
        }
    },

    computed:{

        stages(){
            return this.groups.filter(g => g.type === 'stage');
        },

        tags(){
            return this.groups.filter(g => g.type !== 'stage');
        },

        filtered_tags(){
            if(!this.search) return this.tags;
            const regex = new RegExp(this.search.replace(' ', '.*'), 'i');
            return this.tags.filter(t => regex.test(`${t.type}:${t.name}`));
        },
    },

    watch: {
        'form.name'(){
            if( this.podcast && this.form.slug.length ) return;
            this.form.slug = this.utils.slugify( this.form.name );
        },
        'form.type'(type){
            if(type === 'video' && ! this.form.media?.url){
                this.form.media = {url: ''};
            }else if( type === 'audio' ){
                this.form.media = this.podcast?.media ?? null;
            }
        }
    },

    methods:{

        save(){
            if(this.podcast){
                this.form.put(this.route('pc.update', {podcast: this.podcast.id, ...this.global_url_params}), {
                    onFinish: () => console.log('Updated'),
                });
            } else {
                this.form.post(this.route('pc.store', {...this.global_url_params}), {
                    onFinish: () => console.log('Created'),
                });
            }
        },

    },


    mounted() {
        this.themes = themes;

         if(this.podcast){
            this.form.name              = this.podcast.name;
            this.form.slug              = this.podcast.slug;
            this.form.global_goal_id    = this.podcast.global_goal_id;
            this.form.description       = this.podcast.description;
            this.form.image_file        = this.podcast.image_file;
            this.form.transcript_file   = this.podcast.transcript_file;
            this.form.duration_mins     = this.podcast.duration_mins;
            this.form.difficulty        = this.podcast.difficulty;
            this.form.type              = this.podcast.type;
            this.form.media             = this.podcast.media;
            this.form.course            = this.podcast.course;
            this.form.sponsor.name      = this.podcast.sponsor.name;
            this.form.sponsor.url       = this.podcast.sponsor.url;
            this.form.sponsor.logo      = this.podcast.sponsor.logo;
            this.form.groups            = this.podcast.groups.map(g => g.id);
         }


        this.setTitle( this.podcast ? "Edit Podcast '" + this.form.name + "'" : 'Create Podcast');

    }



}
</script>

<style lang="scss" type="scoped">
textarea{
    min-height: 240px;
}

.stage-row{
    display: flex;
    flex-wrap: wrap;
}

.stage{
    width: 18% !important;
    margin: 1%;
}

.global-goal-row{
    display: flex;
    flex-wrap: wrap;
    margin: 0 -.4rem;
}

.global-goal{
    width: calc(100% / 2);
    flex: 0 0 calc(100% / 2);
    padding: .4rem;
    display: flex;
    align-items: stretch;

    @include media-breakpoint-up(lg){
        width: calc(100% / 3);
        flex: 0 0 calc(100% / 3);
    }

    @include media-breakpoint-up(xl){
        width: calc(100% / 5);
        flex: 0 0 calc(100% / 5);
    }
}


</style>
